import React, {useState, useEffect} from 'react';
import '../App.css';
import TopBar  from '../components/Topbar';
import Footer  from '../components/Footer';
import { Link } from 'react-router-dom';
import { MyProSidebarProvider } from "../components/SidebarContext";
import { Button, Modal, Spinner } from 'react-bootstrap';
import { baseUrl } from '../components/BaseUrl';
import logo from '../assets/img/codefussion.png';
import axios from 'axios';
import moment from 'moment';
import Swal from "sweetalert2";
import { CommentSection } from 'react-comments-section'
import LinearProgress from "@mui/material/LinearProgress";
import 'react-comments-section/dist/index.css'




const Discussions = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState(false);
  const [commenting, setCommenting] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [comment, setComment] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const MAX_CHARS = 3600;
  const [charsLeft, setCharsLeft] = useState(0);

  const inputComment = (e) => {
      setComment(e.target.value);
      if(comment.length > MAX_CHARS ){
        setDisabled(true);
      }
  }


  useEffect(() => {
    fetchDiscussions();
  }, []);


   const postComment = () => {
       if(title === ""){
         Swal.fire({
           title: "Empty Title",
           text: "Post title required",
           icon: "error",
           confirmButtonText: "OK",
           backdrop: `
           rgba(143, 70, 0, 0.3)
           url("")
           left top
           no-repeat
         `
         });
       }else if(comment === ""){
         Swal.fire({
           title: "Empty Post",
           text: "Post is required",
           icon: "error",
           confirmButtonText: "OK",
           backdrop: `
           rgba(143, 70, 0, 0.3)
           url("")
           left top
           no-repeat
         `
         });
       }else{
       const token = localStorage.getItem("codefussion-login-token");
       setCommenting(true);
       setDisabled(true);
       const userData = {
         first_name:  localStorage.getItem("codefussion-student-first-name") ,
         last_name: localStorage.getItem("codefussion-student-last-name"),
         email: localStorage.getItem("codefussion-student-email"),
         profile_photo: localStorage.getItem("codefussion-student-photo"),
         title: title,
         message: comment,
       };
       axios.post(`${baseUrl}post-comment.php`, userData, { headers:
       { Accept: "application/json",
         "Content-Type": "application/json",
         Authorization: token
       }
     }).then((response) => {
       // console.log(response.data)
         if(response.data.message === "Posted added."){
           setCommenting(false);
           setDisabled(false);
           Swal.fire({
             title: "Success",
             text: "Profile updated successfully",
             icon: "success",
             confirmButtonText: "OK",
             backdrop: `
             rgba(143, 70, 0, 0.3)
             url("")
             left top
             no-repeat
           `
         }).then(()=> {
           window.location.replace("/discussions")
         });

         }else{
         Swal.fire({
           title: "Error",
           text: "Error updating recod. Please try again later.",
           icon: "error",
           confirmButtonText: "OK",
           backdrop: `
           rgba(143, 70, 0, 0.3)
           url("")
           left top
           no-repeat
         `
         });
         setCommenting(false);
         setDisabled(false);
       }
       });
     }
   }

  const fetchDiscussions = async () => {
  const token = localStorage.getItem("codefussion-login-token");
  setLoading(true)
  axios.get(`${baseUrl}get-discussion.php`,
    { headers:
      { Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token
      }
    })
   .then(response => {
     setData(response.data);
     setLoading(false);
    })
   .catch((error) => {
     Swal.fire({
       title: "Error",
       text: "An error occurred. Please try again later",
       icon: "error",
       confirmButtonText: "OK",
       backdrop: `
       rgba(143, 70, 0, 0.3)
       url("")
       left top
       no-repeat
     `
     });
     setLoading(false);
    });
  }


  const handleKeyPress = (e) => {

    if (comment.length >= MAX_CHARS) {
        setDisabled(true);
        e.preventDefault();
        e.stopPropagation();
    }
  }

  const showDiscussions = () => {
    if(data.length === 0){
      return(
        <div className="container">
        <div className="row">
        <div>
        <p>There are discussions. Be the first to start one</p>
        </div>
        <div className="container">
        <button className="col-sm-6" onClick={handleShow}>Discuss</button>
        </div>
        </div>
        </div>
      )
    }else{
    return data.map((item, index) => {
    let shortenMessage = item.message.substring(0, 3600).concat('...');
    let shortenTitle = item.title.substring(0, 3600).concat('...');
    return(

   		  <tbody>
   		    <tr>
   		      <th scope="row">{index+1}</th>
   		      <td>
            {item.profile_photo === "" ?
            <img src={logo} class="img-fluid img-thumbnail" alt="user" /> :
   			    <img src={item.profile_photo} class="img-fluid img-thumbnail" alt="user" />
           }
   		      </td>
   		      <td>{shortenTitle}</td>
   		      <td>{`${item.first_name} ${item.last_name}`}</td>
   		      <td>{shortenMessage}</td>
   		      <td>{`${moment(item.date_created).format('LL')}`}</td>
   		      <td><Link to={`/discussion-description/${item.id}`} className="col-sm-12"><button>Read</button></Link></td>
   		    </tr>
   		  </tbody>
    )
    })
  }
}

  return (
  <MyProSidebarProvider>
    {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
    <div>
    <TopBar />

    <div>
    {loading ?<div style={{ marginLeft: 236 }}>
        <div className="loader-wrapper" id="loading">
        <div className="loader">
        <div className="loader loader-inner"></div>
        </div>
        </div>
        </div> :
    <div>
   <h2 className="text-dark mt-4 font-weight-bold">Join the discussion</h2>
   <center>
   {data.length > 0 ? <button style={{ width: '36%' }} className="col-sm-2 mb-4" onClick={handleShow}>Start discussion</button> : null}
   </center>
    <div style={{ width: '100%' }}>
    <table className="table table-condensed" style={{ width: '100%' }}>
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Profile Picture</th>
          <th scope="col">Title</th>
          <th scope="col">Author</th>
          <th scope="col">Comments</th>
          <th scope="col">Date</th>
          <th scope="col">Read</th>
        </tr>
      </thead>
    {showDiscussions()}
    	</table>
    </div>
    </div>}
    </div>
    </div>
    }


  <Modal show={show} onHide={handleClose}>
   <Modal.Header className="bg-info" closeButton>
     <Modal.Title className="bg-info text-dark">Add Post</Modal.Title>
   </Modal.Header>
   <Modal.Body>

<form>
<div class="mb-3">
  <label for="exampleInputEmail1" class="form-label">Title</label>
  <input type="text" class="form-control" onChange={(e) =>setTitle(e.target.value)} aria-describedby="emailHelp" />
</div>
 <div class="form-group mb-4">
 <label for="exampleInputEmail1" class="form-label">Post message</label>
 <textarea className="form-control status-box" onKeyPress={ handleKeyPress } onChange={inputComment} rows="3" placeholder="Enter your post here ..."></textarea>
  </div>
  <span>{MAX_CHARS - comment.length} characters left</span>
  <LinearProgress
   className="charProgress mb-4"
   variant="determinate"
   value={comment.length}
   />

 {comment.length >= MAX_CHARS ?
 <p  className="text-danger">Limit reached</p> : null }

 <button disabled={disabled} type="button" onClick={postComment}>
 {commenting ? (
   <Spinner animation="border" variant="light" size="sm" />
 ) : (
   "Post"
 )}
 </button>

</form>
</Modal.Body>
</Modal>
</MyProSidebarProvider>
  );
}

export default Discussions;
